import React, { Component } from 'react'
import { BUTTON } from './style'
import { IMG } from '../../themes'
export class ButtonIcon extends Component {
  render () {
    const {
      onClick,
      className = '',
      classIcon,
      disabled,
      icon
    } = this.props
    return (
      <BUTTON
        className={className}
        onClick={disabled ? () => {} : onClick}
        disabled={disabled}
      >
        <img
          className={`icon-btn ${classIcon || ''}`}
          src={IMG[icon]}
          alt='icon-btn'
        />
      </BUTTON>
    )
  }
}
